$(document).on('turbolinks:click', function() {
  $("#loading").delay(1500).fadeIn();
  $("#loading_box").delay(1500).fadeIn();
});

$(document).on('turbolinks:render', function() {
  $("#loading").fadeOut();
  $("#loading_box").fadeOut();
});
